import React from "react";
import styled from "styled-components";

/* Discontinued Typography 
- use LfBodyLarge, BodyLarge, or Body 
*/

const StyledBodyText = styled.p`
  font-family: ${({ theme }) => theme.fonts.graphik};
  color: ${({ theme, muted }) =>
    muted ? theme.colors.gray800 : theme.colors.gray1200};
  font-weight: ${({ bold }) => (bold ? 500 : 400)};
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0;
`;

const BodyTxt = ({ children, className, muted, bold, white, error }) => {
  return (
    <StyledBodyText
      className={className}
      white={white}
      error={error}
      muted={muted}
      bold={bold}
    >
      {children}
    </StyledBodyText>
  );
};

BodyTxt.defaultProps = {
  muted: false,
  bold: false
};

export default BodyTxt;
